export const isHighSchoolStudent = (educationPhase) => educationPhase === 'high-school';

export const isCommunityCollegeStudent = (educationPhase) => educationPhase === 'community-college';

export const isUndergraduateStudent = (educationPhase) => educationPhase === 'undergraduate';

export const isAdultLearnerStudent = (educationPhase) => educationPhase === 'adult-learner';

export const isEducatorDemoStudent = (demoType) => demoType === 'Educator';

export const isHighSchoolEducator = (type) => type === 'Teacher' || type === 'Counselor';

export const isHighSchoolMentor = (type) => type === 'Mentor';

export const isCommunityCollegeStaff = (type) => type === 'CommunityCollegeStaff';

export const getUserTypeFromEducationPhase = (educationPhase) => ({
  isHighSchool: isHighSchoolStudent(educationPhase),
  isTransfer: isCommunityCollegeStudent(educationPhase),
  isUndergraduate: isUndergraduateStudent(educationPhase),
  isAdult: isAdultLearnerStudent(educationPhase),
});
